import React from "react"
import {Button, Chip, Badge} from "@heroui/react"
import {
  IconAlertCircle,
  IconBell,
  IconDotsVertical,
  IconSettings,
} from "@tabler/icons-react"

interface AlertsHeaderProps {
  showAlerts: boolean
  onAlertControlClick: () => void
  title: string
  viewMode: "grouped" | "individual"
  onViewModeChange: (mode: "grouped" | "individual") => void
}

export const AlertsHeader: React.FC<AlertsHeaderProps> = ({
  showAlerts,
  onAlertControlClick,
  title,
  viewMode,
  onViewModeChange,
}) => {
  return (
    <div className="mb-4">
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
            <IconAlertCircle className="h-5 w-5 text-primary" />
          </div>
          <h1 className="text-xl font-semibold text-neutral-800">{title}</h1>
          {/* <Chip
            color="primary"
            size="sm"
            variant="flat"
            startContent={<IconBell className="h-3 w-3" />}
          >
            Monitoring Active
          </Chip> */}
        </div>

        <div className="flex items-center gap-2">
          {/* View Mode Toggle */}
          <div className="flex items-center gap-1 rounded-lg border border-gray-200 bg-gray-50 p-1">
            <Button
              size="sm"
              variant={viewMode === "grouped" ? "solid" : "light"}
              color={viewMode === "grouped" ? "primary" : "default"}
              className="text-xs"
              onPress={() => onViewModeChange("grouped")}
            >
              Grouped by Thread
            </Button>
            <Button
              size="sm"
              variant={viewMode === "individual" ? "solid" : "light"}
              color={viewMode === "individual" ? "primary" : "default"}
              className="text-xs"
              onPress={() => onViewModeChange("individual")}
            >
              Individual Alerts
            </Button>
          </div>

          <Button
            variant="bordered"
            size="sm"
            isIconOnly
            className="h-9 w-9 rounded-full border-primary/30 bg-primary/5 shadow-sm transition-colors hover:bg-primary/10"
            onClick={onAlertControlClick}
          >
            <IconSettings className="h-5 w-5 text-primary" />
          </Button>

          {/* <Button
            color="primary"
            size="sm"
            className="font-medium"
            onClick={onAlertControlClick}
          >
            Alerts Control
          </Button> */}
        </div>
      </div>

      {/* {showAlerts && (
        <div className="flex items-center justify-between rounded-lg border border-neutral-200 bg-white/80 px-4 py-2 shadow-sm backdrop-blur">
          <div className="flex items-center gap-3">
            <Badge content="4" color="danger" size="sm" placement="top-right">
              <IconAlertCircle className="h-5 w-5 text-red-500" />
            </Badge>
            <div className="text-sm font-medium text-neutral-700">
              New Alerts Detected
            </div>
          </div>

          <div className="text-xs text-neutral-500">
            Last updated: Today at 11:23 AM
          </div>
        </div>
      )} */}
    </div>
  )
}
